import * as React from 'react';
import { Row, useMediaContext } from 'saladsoft-primitive';
import styled from 'styled-components';
import AnimateOnScroll from 'components/commons/AnimateOnScroll';
const Section02 = () => {
  const { isMobile } = useMediaContext();
  return (
    <StayContainer>
      <UnionWrapper>
        <img src="/images/union.png" alt="union" />
      </UnionWrapper>
      <AnimateOnScroll direction={'up'} amount={0.15}>
        <Row justifyContent="flex-start" gap={0} paddingTop="40px" flexWrap="wrap" height={'auto'}>
          <ImageContainer>
            <StyledImage src="/images/before_01.jpg" alt="icon1" />
            <HoverText>Before</HoverText>
          </ImageContainer>
          <ImageContainer>
            <StyledImage src="/images/after_01.jpg" alt="icon2" />
            <HoverText>After</HoverText>
          </ImageContainer>
        </Row>
      </AnimateOnScroll>
      <AnimateOnScroll direction={'up'} amount={0.15}>
        <Row justifyContent="flex-start" gap={0} paddingTop="20px" flexWrap="wrap" height={'auto'}>
          <ImageContainer>
            <StyledImage src="/images/before_02.jpg" alt="icon1" />
            <HoverText>Before</HoverText>
          </ImageContainer>
          <ImageContainer>
            <StyledImage src="/images/after_02.jpg" alt="icon2" />
            <HoverText>After</HoverText>
          </ImageContainer>
        </Row>
      </AnimateOnScroll>
      <AnimateOnScroll direction={'up'} amount={0.15}>
        <Row justifyContent="flex-start" gap={0} paddingTop="20px" flexWrap="wrap" height={'auto'}>
          <ImageContainer>
            <StyledImage src="/images/before_03.jpg" alt="icon1" />
            <HoverText>Before</HoverText>
          </ImageContainer>
          <ImageContainer>
            <StyledImage src="/images/after_03.jpg" alt="icon2" />
            <HoverText>After</HoverText>
          </ImageContainer>
        </Row>
      </AnimateOnScroll>
    </StayContainer>
  );
};

const StayContainer = styled.div`
  max-width: 100%;
  position: relative;
`;

const UnionWrapper = styled.div`
  width: 100%;
  height: 100%;
  text-align: right;
  position: absolute;
  top: -100px;
  right: 0;
`;

const HoverText = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

const ImageContainer = styled.div`
  flex: 1;
  overflow: hidden;
  object-fit: cover;
  height: 340px;
  position: relative;
  margin: 0;
  @media ${(props) => props.theme.media.mobile} {
    flex: none;
    width: 100%;
    flex-basis: 100%;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
`;

export default Section02;
